import { createContext, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const query = useQuery({ queryKey: ["public-site"], queryFn: async () => (await api.get("/public/site")).data, staleTime: 120_000 });
  const seo = query.data?.seo;

  useEffect(() => {
    if (!seo) return;
    document.title = seo.site_title || "RAHI DEV";
    const set = (sel, attr, value, create) => {
      let el = document.head.querySelector(sel);
      if (!el && create) { el = create(); document.head.appendChild(el); }
      if (el && value !== undefined) el.setAttribute(attr, value);
    };
    const meta = (name, prop) => () => { const m = document.createElement("meta"); m.setAttribute(prop ? "property" : "name", name); return m; };
    set('meta[name="description"]', "content", seo.meta_description || "", meta("description"));
    set('meta[property="og:title"]', "content", seo.og_title || seo.site_title || "", meta("og:title", true));
    set('meta[property="og:description"]', "content", seo.og_description || seo.meta_description || "", meta("og:description", true));
    if (seo.og_image) set('meta[property="og:image"]', "content", seo.og_image, meta("og:image", true));
    if (seo.canonical_url) set('link[rel="canonical"]', "href", seo.canonical_url, () => { const l = document.createElement("link"); l.rel = "canonical"; return l; });
    const favicon = query.data?.settings?.favicon;
    if (favicon) set('link[rel="icon"]', "href", favicon.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${favicon}` : favicon, () => { const l = document.createElement("link"); l.rel = "icon"; return l; });
  }, [seo, query.data?.settings?.favicon]);

  return <SiteContext.Provider value={query}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
